
/*
import React, { useState, useEffect } from 'react';

const API_URL = `${process.env.REACT_APP_API_URL}/api/vehicles`;
const PHONE_NUMBER = '+97517242482';

function VehicleList() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hoveredCard, setHoveredCard] = useState(null);

  const fetchVehicles = async () => {
    try {
      const res = await fetch(API_URL);
      const result = await res.json();
      if (res.ok) {
        setVehicles(result.data || []);
      }
    } catch (err) {
      console.error('Failed to load vehicles:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  const formatPrice = (price) => {
    if (!price || String(price).trim() === '') return '';
    const cleaned = String(price).replace(/[^0-9]/g, '');
    const num = parseInt(cleaned, 10);
    return isNaN(num) ? price : num.toLocaleString();
  };

  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
          color: '#C7B381',
          fontSize: '2rem',
          fontWeight: '300',
        }}
      >
        Loading luxury collection...
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          position: 'fixed',
          right: '30px',
          bottom: '30px',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          zIndex: 1000,
        }}
      >
        <a
          href={`tel:${PHONE_NUMBER}`}
          style={{
            width: '60px',
            height: '60px',
            background: '#4CAF50',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 30px rgba(76, 175, 80, 0.4)',
            transition: 'all 0.3s',
            fontSize: '1.8rem',
            transform: 'scale(1)',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.15)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          📞
        </a>

        <a
          href={`https://wa.me/${PHONE_NUMBER.replace(/[^0-9]/g, '')}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: '60px',
            height: '60px',
            background: '#25D366',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 30px rgba(37, 211, 102, 0.4)',
            transition: 'all 0.3s',
            transform: 'scale(1)',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.15)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          <svg viewBox="0 0 24 24" width="34" height="34" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.198.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.884 3.088" />
          </svg>
        </a>
      </div>

      <div
        style={{
          minHeight: '100vh',
          background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
          color: '#E8E8E8',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        <div style={{ padding: '6rem 2rem 8rem', maxWidth: '1600px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '6rem' }}>
            <h1
              style={{
                fontSize: '4rem',
                fontWeight: '300',
                marginBottom: '1.5rem',
                color: '#FFFFFF',
                letterSpacing: '-0.01em',
              }}
            >
              Luxury <span style={{ fontWeight: '600', color: '#C7B381' }}>Fleet</span>
            </h1>
            <p
              style={{
                fontSize: '1.2rem',
                color: '#B8B8B8',
                maxWidth: '700px',
                margin: '0 auto',
                lineHeight: '1.8',
                fontWeight: '300',
              }}
            >
              Discover our handpicked selection of the world's finest Electric Vehicles
            </p>
          </div>

          {vehicles.length > 0 ? (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(420px, 1fr))',
                gap: '3rem',
              }}
            >
              {vehicles.map((vehicle) => {
                const displayPrice = vehicle.displayPrice?.trim() || '';
                const hasPromo = !!displayPrice;

                return (
                  <div
                    key={vehicle._id}
                    onMouseEnter={() => setHoveredCard(vehicle._id)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{
                      background: 'rgba(15, 20, 25, 0.6)',
                      border: '1px solid rgba(199, 179, 129, 0.15)',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                      transform: hoveredCard === vehicle._id ? 'translateY(-12px)' : 'translateY(0)',
                      boxShadow:
                        hoveredCard === vehicle._id
                          ? '0 32px 64px rgba(0,0,0,0.5), 0 0 0 1px rgba(199,179,129,0.3)'
                          : '0 8px 32px rgba(0,0,0,0.3)',
                    }}
                  >
                    <div style={{ position: 'relative', overflow: 'hidden', height: '320px' }}>
                      <img
                        src={vehicle.imageURL}
                        alt={vehicle.name}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
                          transform: hoveredCard === vehicle._id ? 'scale(1.1)' : 'scale(1)',
                        }}
                      />
                      <div
                        style={{
                          position: 'absolute',
                          inset: 0,
                          background:
                            hoveredCard === vehicle._id
                              ? 'linear-gradient(to top, rgba(15,20,25,0.8) 0%, transparent 50%)'
                              : 'linear-gradient(to top, rgba(15,20,25,0.6) 0%, transparent 50%)',
                          transition: 'all 0.4s',
                        }}
                      />
                    </div>

                    <div style={{ padding: '2.5rem' }}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          marginBottom: '1.5rem',
                        }}
                      >
                        <div>
                          <h3
                            style={{
                              fontSize: '1.8rem',
                              fontWeight: '400',
                              color: '#FFFFFF',
                              marginBottom: '0.5rem',
                              letterSpacing: '-0.01em',
                            }}
                          >
                            {vehicle.name}
                          </h3>
                          <div
                            style={{
                              fontSize: '0.8rem',
                              color: '#C7B381',
                              letterSpacing: '0.1em',
                              textTransform: 'uppercase',
                              fontWeight: '500',
                            }}
                          >
                            {vehicle.status}
                          </div>
                        </div>

                        <div style={{ textAlign: 'right' }}>
                          <div
                            style={{
                              fontSize: hasPromo ? '2.4rem' : '2.2rem',
                              fontWeight: '300',
                              color: '#C7B381',
                              lineHeight: '1.2',
                              display: 'flex',
                              alignItems: 'baseline',
                              justifyContent: 'flex-end',
                              gap: '0.4rem',
                            }}
                          >
                            <span style={{ fontSize: '1.4rem', opacity: '0.9' }}>Nu.</span>
                            <span>{formatPrice(hasPromo ? displayPrice : vehicle.price)}</span>
                          </div>

                          {hasPromo && (
                            <div
                              style={{
                                fontSize: '1.5rem',
                                color: '#888',
                                textDecoration: 'line-through',
                                marginTop: '0.6rem',
                                fontWeight: '300',
                                display: 'flex',
                                alignItems: 'baseline',
                                justifyContent: 'flex-end',
                                gap: '0.4rem',
                              }}
                            >
                              <span style={{ fontSize: '1.1rem', opacity: '0.8' }}>Nu.</span>
                              <span>{formatPrice(vehicle.price)}</span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div
                        style={{
                          padding: '1.5rem 0',
                          borderTop: '1px solid rgba(199, 179, 129, 0.1)',
                          borderBottom: '1px solid rgba(199, 179, 129, 0.1)',
                          marginBottom: '1.5rem',
                          color: '#B8B8B8',
                          lineHeight: '1.8',
                        }}
                      >
                        <p>
                          <strong>Color:</strong> {vehicle.color}
                        </p>
                        <p>
                          <strong>Details:</strong> {vehicle.details}
                        </p>
                      </div>

                      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                        {vehicle.brochureURL && (
                          <a
                            href={vehicle.brochureURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              flex: 1,
                              padding: '1rem',
                              background: '#C7B381',
                              color: '#0F1419',
                              textAlign: 'center',
                              borderRadius: '6px',
                              textDecoration: 'none',
                              fontWeight: '600',
                              fontSize: '0.95rem',
                            }}
                          >
                            View Brochure
                          </a>
                        )}
                        {vehicle.videoURL && (
                          <a
                            href={vehicle.videoURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              flex: 1,
                              padding: '1rem',
                              background: 'transparent',
                              color: '#C7B381',
                              textAlign: 'center',
                              border: '1px solid rgba(199, 179, 129, 0.4)',
                              borderRadius: '6px',
                              textDecoration: 'none',
                              fontWeight: '600',
                              fontSize: '0.95rem',
                            }}
                          >
                            Watch Video
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '120px', color: '#888' }}>
              <h2 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#C7B381' }}>
                No vehicles in collection
              </h2>
              <p style={{ fontSize: '1.3rem' }}>The luxury fleet is currently empty</p>
            </div>
          )}

          <div
            style={{
              marginTop: '6rem',
              padding: '4rem',
              background: 'linear-gradient(135deg, rgba(199, 179, 129, 0.1) 0%, rgba(199, 179, 129, 0.05) 100%)',
              border: '1px solid rgba(199, 179, 129, 0.2)',
              borderRadius: '16px',
              textAlign: 'center',
            }}
          >
            <h2
              style={{
                fontSize: '2.5rem',
                fontWeight: '400',
                color: '#FFFFFF',
                marginBottom: '1.5rem',
                letterSpacing: '-0.01em',
              }}
            >
              Discover <span style={{ fontWeight: '600', color: '#C7B381' }}>More Vehicles</span>
            </h2>
            <p
              style={{
                fontSize: '1.2rem',
                color: '#B8B8B8',
                maxWidth: '700px',
                margin: '0 auto 3rem auto',
                lineHeight: '1.8',
                fontWeight: '300',
              }}
            >
              Explore our complete collection of luxury electric vehicles. Download our app to see
              all available models and connect with us directly.
            </p>

            <div
              style={{
                display: 'flex',
                gap: '1.5rem',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap',
              }}
            >
              <a
                href="
https://play.google.com/store/apps/details?id=com.company.showroom
" // ← replace with real link
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.8rem',
                  padding: '1.2rem 2.5rem',
                  background: 'rgba(199, 179, 129, 0.1)',
                  color: '#C7B381',
                  border: '1px solid rgba(199, 179, 129, 0.3)',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '1.05rem',
                  textDecoration: 'none',
                  transition: 'all 0.3s',
                }}
                onMouseEnter={(e) => {
                  Object.assign(e.currentTarget.style, {
                    background: 'rgba(199, 179, 129, 0.2)',
                    borderColor: '#C7B381',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 20px rgba(199, 179, 129, 0.2)',
                  });
                }}
                onMouseLeave={(e) => {
                  Object.assign(e.currentTarget.style, {
                    background: 'rgba(199, 179, 129, 0.1)',
                    borderColor: 'rgba(199, 179, 129, 0.3)',
                    transform: 'translateY(0)',
                    boxShadow: 'none',
                  });
                }}
              >
                <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                </svg>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '0.75rem', opacity: 0.8, fontWeight: '300' }}>
                    GET IT ON
                  </div>
                  <div style={{ fontSize: '1.05rem', fontWeight: '600' }}>Google Play</div>
                </div>
              </a>

              <a
                href=" https://apps.apple.com/app/st-motors-ev/id6754755756" // ← replace with real link
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.8rem',
                  padding: '1.2rem 2.5rem',
                  background: 'rgba(199, 179, 129, 0.1)',
                  color: '#C7B381',
                  border: '1px solid rgba(199, 179, 129, 0.3)',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '1.05rem',
                  textDecoration: 'none',
                  transition: 'all 0.3s',
                }}
                onMouseEnter={(e) => {
                  Object.assign(e.currentTarget.style, {
                    background: 'rgba(199, 179, 129, 0.2)',
                    borderColor: '#C7B381',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 20px rgba(199, 179, 129, 0.2)',
                  });
                }}
                onMouseLeave={(e) => {
                  Object.assign(e.currentTarget.style, {
                    background: 'rgba(199, 179, 129, 0.1)',
                    borderColor: 'rgba(199, 179, 129, 0.3)',
                    transform: 'translateY(0)',
                    boxShadow: 'none',
                  });
                }}
              >
                <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
                  <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z" />
                </svg>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '0.75rem', opacity: 0.8, fontWeight: '300' }}>
                    Download on the
                  </div>
                  <div style={{ fontSize: '1.05rem', fontWeight: '600' }}>App Store</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VehicleList;*/

/*
import React, { useState, useEffect, useCallback } from 'react';

const PHONE_NUMBER = '+97517242482';

function VehicleList() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);

  const fetchVehicles = useCallback(async () => {
    setLoading(true);
    setError(null);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10s timeout

    try {
      const res = await fetch('/api/vehicles', { // ← use proxy path
        signal: controller.signal,
        headers: {
          Accept: 'application/json',
          'X-API-Key': process.env.REACT_APP_VEHICLES_API_KEY || '', // ← required for auth
        },
        credentials: 'same-origin',
      });

      clearTimeout(timeoutId);

      if (!res.ok) {
        if (res.status === 401) {
          throw new Error('Unauthorized - check API key');
        }
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      const result = await res.json();

      if (result.success && Array.isArray(result.data)) {
        setVehicles(result.data);
      } else {
        setError('Invalid data format from server');
      }
    } catch (err) {
      if (err.name === 'AbortError') {
        setError('Request timed out');
      } else {
        setError(err.message || 'Failed to load vehicles');
      }
      console.error('Fetch error:', err);
    } finally {
      setLoading(false);
    }

    return () => {
      controller.abort();
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    fetchVehicles();
  }, [fetchVehicles]);

  const formatPrice = (price) => {
    if (!price || String(price).trim() === '') return 'Contact for pricing';
    const cleaned = String(price).replace(/[^0-9]/g, '');
    const num = parseInt(cleaned, 10);
    return isNaN(num) ? price : `Nu. ${num.toLocaleString()}`;
  };

  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
          color: '#C7B381',
          fontSize: '2rem',
          fontWeight: '300',
        }}
      >
        Loading luxury collection...
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
          color: '#ff6b6b',
          textAlign: 'center',
          padding: '2rem',
        }}
      >
        <h2 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⚠️ Error</h2>
        <p style={{ fontSize: '1.3rem', maxWidth: '600px' }}>{error}</p>
        <button
          onClick={fetchVehicles}
          style={{
            marginTop: '2rem',
            padding: '1rem 2.5rem',
            background: '#C7B381',
            color: '#0F1419',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1.1rem',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <>
      <div style={{ position: 'fixed', right: '30px', bottom: '30px', zIndex: 1000, display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <a
          href={`tel:${PHONE_NUMBER}`}
          style={{
            width: '60px',
            height: '60px',
            background: '#4CAF50',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 30px rgba(76,175,80,0.4)',
            transition: 'all 0.3s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.15)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          📞
        </a>

        <a
          href={`https://wa.me/${PHONE_NUMBER.replace(/[^0-9]/g, '')}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: '60px',
            height: '60px',
            background: '#25D366',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 30px rgba(37,211,102,0.4)',
            transition: 'all 0.3s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.15)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          <svg viewBox="0 0 24 24" width="34" height="34" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.198.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.884 3.088" />
          </svg>
        </a>
      </div>

      <div
        style={{
          minHeight: '100vh',
          background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
          color: '#E8E8E8',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        <div style={{ padding: '6rem 2rem 8rem', maxWidth: '1600px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '6rem' }}>
            <h1
              style={{
                fontSize: '4rem',
                fontWeight: '300',
                marginBottom: '1.5rem',
                color: '#FFFFFF',
                letterSpacing: '-0.01em',
              }}
            >
              Luxury <span style={{ fontWeight: '600', color: '#C7B381' }}>Fleet</span>
            </h1>
            <p
              style={{
                fontSize: '1.2rem',
                color: '#B8B8B8',
                maxWidth: '700px',
                margin: '0 auto',
                lineHeight: '1.8',
                fontWeight: '300',
              }}
            >
              Discover our handpicked selection of the world's finest Electric Vehicles
            </p>
          </div>

          {vehicles.length > 0 ? (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(420px, 1fr))',
                gap: '3rem',
              }}
            >
              {vehicles.map((vehicle) => {
                const displayPrice = vehicle.displayPrice?.trim() || '';
                const hasPromo = !!displayPrice;

                return (
                  <div
                    key={vehicle._id}
                    onMouseEnter={() => setHoveredCard(vehicle._id)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{
                      background: 'rgba(15, 20, 25, 0.6)',
                      border: '1px solid rgba(199, 179, 129, 0.15)',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                      transform: hoveredCard === vehicle._id ? 'translateY(-12px)' : 'translateY(0)',
                      boxShadow:
                        hoveredCard === vehicle._id
                          ? '0 32px 64px rgba(0,0,0,0.5), 0 0 0 1px rgba(199,179,129,0.3)'
                          : '0 8px 32px rgba(0,0,0,0.3)',
                    }}
                  >
                    <div style={{ position: 'relative', overflow: 'hidden', height: '320px' }}>
                      <img
                        src={vehicle.imageURL}
                        alt={vehicle.name}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
                          transform: hoveredCard === vehicle._id ? 'scale(1.1)' : 'scale(1)',
                        }}
                      />
                      <div
                        style={{
                          position: 'absolute',
                          inset: 0,
                          background:
                            hoveredCard === vehicle._id
                              ? 'linear-gradient(to top, rgba(15,20,25,0.8) 0%, transparent 50%)'
                              : 'linear-gradient(to top, rgba(15,20,25,0.6) 0%, transparent 50%)',
                          transition: 'all 0.4s',
                        }}
                      />
                    </div>

                    <div style={{ padding: '2.5rem' }}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          marginBottom: '1.5rem',
                        }}
                      >
                        <div>
                          <h3
                            style={{
                              fontSize: '1.8rem',
                              fontWeight: '400',
                              color: '#FFFFFF',
                              marginBottom: '0.5rem',
                              letterSpacing: '-0.01em',
                            }}
                          >
                            {vehicle.name}
                          </h3>
                          <div
                            style={{
                              fontSize: '0.8rem',
                              color: '#C7B381',
                              letterSpacing: '0.1em',
                              textTransform: 'uppercase',
                              fontWeight: '500',
                            }}
                          >
                            {vehicle.status}
                          </div>
                        </div>

                        <div style={{ textAlign: 'right' }}>
                          <div
                            style={{
                              fontSize: hasPromo ? '2.4rem' : '2.2rem',
                              fontWeight: '300',
                              color: '#C7B381',
                              lineHeight: '1.2',
                              display: 'flex',
                              alignItems: 'baseline',
                              justifyContent: 'flex-end',
                              gap: '0.4rem',
                            }}
                          >
                            <span style={{ fontSize: '1.4rem', opacity: '0.9' }}>Nu.</span>
                            <span>{formatPrice(hasPromo ? displayPrice : vehicle.price)}</span>
                          </div>

                          {hasPromo && (
                            <div
                              style={{
                                fontSize: '1.5rem',
                                color: '#888',
                                textDecoration: 'line-through',
                                marginTop: '0.6rem',
                                fontWeight: '300',
                                display: 'flex',
                                alignItems: 'baseline',
                                justifyContent: 'flex-end',
                                gap: '0.4rem',
                              }}
                            >
                              <span style={{ fontSize: '1.1rem', opacity: '0.8' }}>Nu.</span>
                              <span>{formatPrice(vehicle.price)}</span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div
                        style={{
                          padding: '1.5rem 0',
                          borderTop: '1px solid rgba(199, 179, 129, 0.1)',
                          borderBottom: '1px solid rgba(199, 179, 129, 0.1)',
                          marginBottom: '1.5rem',
                          color: '#B8B8B8',
                          lineHeight: '1.8',
                        }}
                      >
                        <p>
                          <strong>Color:</strong> {vehicle.color}
                        </p>
                        <p>
                          <strong>Details:</strong> {vehicle.details}
                        </p>
                      </div>

                      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                        {vehicle.brochureURL && (
                          <a
                            href={vehicle.brochureURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              flex: 1,
                              padding: '1rem',
                              background: '#C7B381',
                              color: '#0F1419',
                              textAlign: 'center',
                              borderRadius: '6px',
                              textDecoration: 'none',
                              fontWeight: '600',
                            }}
                          >
                            View Brochure
                          </a>
                        )}
                        {vehicle.videoURL && (
                          <a
                            href={vehicle.videoURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              flex: 1,
                              padding: '1rem',
                              background: 'transparent',
                              color: '#C7B381',
                              textAlign: 'center',
                              border: '1px solid rgba(199, 179, 129, 0.4)',
                              borderRadius: '6px',
                              textDecoration: 'none',
                              fontWeight: '600',
                            }}
                          >
                            Watch Video
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '120px', color: '#888' }}>
              <h2 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#C7B381' }}>
                No vehicles in collection
              </h2>
              <p style={{ fontSize: '1.3rem' }}>The luxury fleet is currently empty</p>
            </div>
          )}

          <div
            style={{
              marginTop: '6rem',
              padding: '4rem',
              background: 'linear-gradient(135deg, rgba(199, 179, 129, 0.1) 0%, rgba(199, 179, 129, 0.05) 100%)',
              border: '1px solid rgba(199, 179, 129, 0.2)',
              borderRadius: '16px',
              textAlign: 'center',
            }}
          >
            <h2
              style={{
                fontSize: '2.5rem',
                fontWeight: '400',
                color: '#FFFFFF',
                marginBottom: '1.5rem',
                letterSpacing: '-0.01em',
              }}
            >
              Discover <span style={{ fontWeight: '600', color: '#C7B381' }}>More Vehicles</span>
            </h2>
            <p
              style={{
                fontSize: '1.2rem',
                color: '#B8B8B8',
                maxWidth: '700px',
                margin: '0 auto 3rem auto',
                lineHeight: '1.8',
                fontWeight: '300',
              }}
            >
              Explore our complete collection of luxury electric vehicles. Download our app to see
              all available models and connect with us directly.
            </p>

            <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a
                href="https://play.google.com/store/apps/details?id=com.company.showroom"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.8rem',
                  padding: '1.2rem 2.5rem',
                  background: 'rgba(199, 179, 129, 0.1)',
                  color: '#C7B381',
                  border: '1px solid rgba(199, 179, 129, 0.3)',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '1.05rem',
                  textDecoration: 'none',
                  transition: 'all 0.3s',
                }}
              >
                <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                </svg>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '0.75rem', opacity: 0.8 }}>GET IT ON</div>
                  <div style={{ fontSize: '1.05rem', fontWeight: '600' }}>Google Play</div>
                </div>
              </a>

              <a
                href="https://apps.apple.com/app/st-motors-ev/id6754755756"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.8rem',
                  padding: '1.2rem 2.5rem',
                  background: 'rgba(199, 179, 129, 0.1)',
                  color: '#C7B381',
                  border: '1px solid rgba(199, 179, 129, 0.3)',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '1.05rem',
                  textDecoration: 'none',
                  transition: 'all 0.3s',
                }}
              >
                <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '0.75rem', opacity: 0.8 }}>Download on the</div>
                  <div style={{ fontSize: '1.05rem', fontWeight: '600' }}>App Store</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VehicleList;*/
import React, { useState, useEffect, useCallback } from 'react';

const PHONE_NUMBER = '+97517242482';

function VehicleList() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);


  const fetchVehicles = useCallback(async () => {
  setLoading(true);
  setError(null);

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000);

  try {
    // Use the environment variable
    const apiUrl = process.env.REACT_APP_API_URL ;
    
    const res = await fetch(`${apiUrl}/api/vehicles`, {
      signal: controller.signal,
      headers: {
        Accept: 'application/json',
        'X-API-Key': process.env.REACT_APP_VEHICLES_API_KEY || '',
      },
      mode: 'cors', // Changed from 'credentials: same-origin'
    });

    clearTimeout(timeoutId);

    if (!res.ok) {
      if (res.status === 401) {
        throw new Error('Unauthorized - check API key');
      }
      throw new Error(`HTTP error! Status: ${res.status}`);
    }

    const result = await res.json();

    if (result.success && Array.isArray(result.data)) {
      setVehicles(result.data);
    } else {
      setError('Invalid data format from server');
    }
  } catch (err) {
    if (err.name === 'AbortError') {
      setError('Request timed out');
    } else {
      setError(err.message || 'Failed to load vehicles');
    }
    console.error('Fetch error:', err);
  } finally {
    setLoading(false);
  }
}, []);
  useEffect(() => {
    fetchVehicles();
  }, [fetchVehicles]);

  const formatPrice = (price) => {
    if (!price || String(price).trim() === '') return 'Contact for pricing';
    const cleaned = String(price).replace(/[^0-9]/g, '');
    const num = parseInt(cleaned, 10);
    return isNaN(num) ? price : num.toLocaleString();
  };

  const isComingSoon = (status) => {
    return status && status.toLowerCase().includes('coming soon');
  };

  const hasValidContent = (value) => {
    return value && String(value).trim() !== '';
  };

  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
          color: '#C7B381',
          fontSize: 'clamp(1.5rem, 4vw, 2rem)',
          fontWeight: '300',
          padding: '1rem',
          textAlign: 'center',
        }}
      >
        Loading luxury collection...
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
          color: '#ff6b6b',
          textAlign: 'center',
          padding: '2rem',
        }}
      >
        <h2 style={{ fontSize: 'clamp(1.8rem, 5vw, 2.5rem)', marginBottom: '1rem' }}>⚠️ Error</h2>
        <p style={{ fontSize: 'clamp(1rem, 3vw, 1.3rem)', maxWidth: '600px' }}>{error}</p>
        <button
          onClick={fetchVehicles}
          style={{
            marginTop: '2rem',
            padding: '1rem 2.5rem',
            background: '#C7B381',
            color: '#0F1419',
            border: 'none',
            borderRadius: '8px',
            fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <>
      {/* Floating Buttons */}
      <div
        style={{
          position: 'fixed',
          right: 'clamp(15px, 3vw, 30px)',
          bottom: 'clamp(15px, 3vw, 30px)',
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          gap: 'clamp(10px, 2vw, 15px)',
        }}
      >
        <a
          href={`tel:${PHONE_NUMBER}`}
          style={{
            width: 'clamp(50px, 10vw, 60px)',
            height: 'clamp(50px, 10vw, 60px)',
            background: '#4CAF50',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 30px rgba(76,175,80,0.4)',
            transition: 'all 0.3s',
            fontSize: 'clamp(1.5rem, 4vw, 2rem)',
            textDecoration: 'none',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.15)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          📞
        </a>

        <a
          href={`https://wa.me/${PHONE_NUMBER.replace(/[^0-9]/g, '')}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: 'clamp(50px, 10vw, 60px)',
            height: 'clamp(50px, 10vw, 60px)',
            background: '#25D366',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 30px rgba(37,211,102,0.4)',
            transition: 'all 0.3s',
            textDecoration: 'none',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.15)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          <svg viewBox="0 0 24 24" width="70%" height="70%" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.198.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.884 3.088" />
          </svg>
        </a>
      </div>

      <div
        style={{
          minHeight: '100vh',
          background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
          color: '#E8E8E8',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        <div
          style={{
            padding: 'clamp(3rem, 8vw, 6rem) clamp(1rem, 4vw, 2rem) clamp(4rem, 10vw, 8rem)',
            maxWidth: '1600px',
            margin: '0 auto',
          }}
        >
          <div style={{ textAlign: 'center', marginBottom: 'clamp(3rem, 8vw, 6rem)' }}>
            <h1
              style={{
                fontSize: 'clamp(2.5rem, 8vw, 4rem)',
                fontWeight: '300',
                marginBottom: '1.5rem',
                color: '#FFFFFF',
                letterSpacing: '-0.01em',
              }}
            >
              Luxury <span style={{ fontWeight: '600', color: '#C7B381' }}>Fleet</span>
            </h1>
            <p
              style={{
                fontSize: 'clamp(1rem, 3vw, 1.2rem)',
                color: '#B8B8B8',
                maxWidth: '700px',
                margin: '0 auto',
                lineHeight: '1.8',
                fontWeight: '300',
                padding: '0 1rem',
              }}
            >
              Discover our handpicked selection of the world's finest Electric Vehicles
            </p>
          </div>

          {vehicles.length > 0 ? (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 350px), 1fr))',
                gap: 'clamp(1.5rem, 4vw, 3rem)',
              }}
            >
              {vehicles.map((vehicle) => {
                const displayPrice = vehicle.displayPrice?.trim() || '';
                const hasPromo = !!displayPrice;
                const showComingSoon = isComingSoon(vehicle.status);
                const hasColor = hasValidContent(vehicle.color);
                const hasDetails = hasValidContent(vehicle.details);

                return (
                  <div
                    key={vehicle._id}
                    onMouseEnter={() => setHoveredCard(vehicle._id)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{
                      background: 'rgba(15, 20, 25, 0.6)',
                      border: '1px solid rgba(199, 179, 129, 0.15)',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                      transform: hoveredCard === vehicle._id ? 'translateY(-12px)' : 'translateY(0)',
                      boxShadow:
                        hoveredCard === vehicle._id
                          ? '0 32px 64px rgba(0,0,0,0.5), 0 0 0 1px rgba(199,179,129,0.3)'
                          : '0 8px 32px rgba(0,0,0,0.3)',
                    }}
                  >
                    <div style={{ position: 'relative', overflow: 'hidden', height: 'clamp(250px, 40vw, 320px)' }}>
                      {/* Coming Soon Tag */}
                      {showComingSoon && (
                        <div
                          style={{
                            position: 'absolute',
                            top: '20px',
                            right: '20px',
                            background: '#DC2626',
                            color: '#FFFFFF',
                            padding: '0.5rem 1.2rem',
                            borderRadius: '6px',
                            fontSize: 'clamp(0.75rem, 2vw, 0.85rem)',
                            fontWeight: '700',
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            zIndex: 10,
                            boxShadow: '0 4px 12px rgba(220, 38, 38, 0.4)',
                          }}
                        >
                          Coming Soon
                        </div>
                      )}

                      <img
                        src={vehicle.imageURL}
                        alt={vehicle.name}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
                          transform: hoveredCard === vehicle._id ? 'scale(1.1)' : 'scale(1)',
                        }}
                      />
                      <div
                        style={{
                          position: 'absolute',
                          inset: 0,
                          background:
                            hoveredCard === vehicle._id
                              ? 'linear-gradient(to top, rgba(15,20,25,0.8) 0%, transparent 50%)'
                              : 'linear-gradient(to top, rgba(15,20,25,0.6) 0%, transparent 50%)',
                          transition: 'all 0.4s',
                        }}
                      />
                    </div>

                    <div style={{ padding: 'clamp(1.5rem, 4vw, 2.5rem)' }}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          marginBottom: '1.5rem',
                          gap: '1rem',
                          flexWrap: 'wrap',
                        }}
                      >
                        <div style={{ flex: '1 1 60%', minWidth: '0' }}>
                          <h3
                            style={{
                              fontSize: 'clamp(1.4rem, 4vw, 1.8rem)',
                              fontWeight: '400',
                              color: '#FFFFFF',
                              marginBottom: '0.5rem',
                              letterSpacing: '-0.01em',
                              wordBreak: 'break-word',
                            }}
                          >
                            {vehicle.name}
                          </h3>
                          {!showComingSoon && (
                            <div
                              style={{
                                fontSize: 'clamp(0.7rem, 2vw, 0.8rem)',
                                color: '#C7B381',
                                letterSpacing: '0.1em',
                                textTransform: 'uppercase',
                                fontWeight: '500',
                              }}
                            >
                              {vehicle.status}
                            </div>
                          )}
                        </div>

                        {/* PRICE SECTION */}
                        <div style={{ textAlign: 'right', flex: '1 1 auto' }}>
                          <div
                            style={{
                              fontSize: hasPromo ? 'clamp(1.8rem, 5vw, 2.4rem)' : 'clamp(1.6rem, 4.5vw, 2.2rem)',
                              fontWeight: '300',
                              color: '#C7B381',
                              lineHeight: '1.2',
                              display: 'flex',
                              alignItems: 'baseline',
                              justifyContent: 'flex-end',
                              gap: '0.4rem',
                              flexWrap: 'wrap',
                            }}
                          >
                            <span style={{ fontSize: 'clamp(1rem, 3vw, 1.4rem)', opacity: '0.9' }}>Nu.</span>
                            <span>{formatPrice(hasPromo ? displayPrice : vehicle.price)}+GST</span>
                          </div>

                          {hasPromo && (
                            <div
                              style={{
                                fontSize: 'clamp(1.1rem, 3vw, 1.5rem)',
                                color: '#888',
                                textDecoration: 'line-through',
                                marginTop: '0.6rem',
                                fontWeight: '300',
                                display: 'flex',
                                alignItems: 'baseline',
                                justifyContent: 'flex-end',
                                gap: '0.4rem',
                                flexWrap: 'wrap',
                              }}
                            >
                              <span style={{ fontSize: 'clamp(0.85rem, 2.5vw, 1.1rem)', opacity: '0.8' }}>Nu.</span>
                              <span>{formatPrice(vehicle.price)}</span>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Color and Details - Only show if they have valid content */}
                      {(hasColor || hasDetails) && (
                        <div
                          style={{
                            padding: 'clamp(1rem, 3vw, 1.5rem) 0',
                            borderTop: '1px solid rgba(199, 179, 129, 0.1)',
                            borderBottom: '1px solid rgba(199, 179, 129, 0.1)',
                            marginBottom: '1.5rem',
                            color: '#B8B8B8',
                            lineHeight: '1.8',
                            fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                          }}
                        >
                          {hasColor && (
                            <p style={{ margin: '0 0 0.5rem 0' }}>
                              <strong>Color:</strong> {vehicle.color}
                            </p>
                          )}
                          {hasDetails && (
                            <p style={{ margin: '0' }}>
                              <strong>Details:</strong> {vehicle.details}
                            </p>
                          )}
                        </div>
                      )}

                      <div
                        style={{
                          display: 'flex',
                          gap: '1rem',
                          flexWrap: 'wrap',
                        }}
                      >
                        {vehicle.brochureURL && (
                          <a
                            href={vehicle.brochureURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              flex: '1 1 calc(50% - 0.5rem)',
                              minWidth: '120px',
                              padding: 'clamp(0.8rem, 2vw, 1rem)',
                              background: '#C7B381',
                              color: '#0F1419',
                              textAlign: 'center',
                              borderRadius: '6px',
                              textDecoration: 'none',
                              fontWeight: '600',
                              fontSize: 'clamp(0.85rem, 2vw, 1rem)',
                              transition: 'all 0.3s',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = '#D4C599';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = '#C7B381';
                            }}
                          >
                            View Brochure
                          </a>
                        )}
                        {vehicle.videoURL && (
                          <a
                            href={vehicle.videoURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              flex: '1 1 calc(50% - 0.5rem)',
                              minWidth: '120px',
                              padding: 'clamp(0.8rem, 2vw, 1rem)',
                              background: 'transparent',
                              color: '#C7B381',
                              textAlign: 'center',
                              border: '1px solid rgba(199, 179, 129, 0.4)',
                              borderRadius: '6px',
                              textDecoration: 'none',
                              fontWeight: '600',
                              fontSize: 'clamp(0.85rem, 2vw, 1rem)',
                              transition: 'all 0.3s',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = 'rgba(199, 179, 129, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = 'transparent';
                            }}
                          >
                            Watch Video
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div
              style={{
                textAlign: 'center',
                padding: 'clamp(60px, 15vw, 120px)',
                color: '#888',
              }}
            >
              <h2
                style={{
                  fontSize: 'clamp(1.8rem, 5vw, 2.5rem)',
                  marginBottom: '20px',
                  color: '#C7B381',
                }}
              >
                No vehicles in collection
              </h2>
              <p style={{ fontSize: 'clamp(1rem, 3vw, 1.3rem)' }}>The luxury fleet is currently empty</p>
            </div>
          )}

          {/* App Download CTA */}
          <div
            style={{
              marginTop: 'clamp(3rem, 8vw, 6rem)',
              padding: 'clamp(2rem, 6vw, 4rem)',
              background: 'linear-gradient(135deg, rgba(199, 179, 129, 0.1) 0%, rgba(199, 179, 129, 0.05) 100%)',
              border: '1px solid rgba(199, 179, 129, 0.2)',
              borderRadius: '16px',
              textAlign: 'center',
            }}
          >
            <h2
              style={{
                fontSize: 'clamp(1.8rem, 5vw, 2.5rem)',
                fontWeight: '400',
                color: '#FFFFFF',
                marginBottom: '1.5rem',
                letterSpacing: '-0.01em',
              }}
            >
              Discover <span style={{ fontWeight: '600', color: '#C7B381' }}>More Vehicles</span>
            </h2>
            <p
              style={{
                fontSize: 'clamp(1rem, 3vw, 1.2rem)',
                color: '#B8B8B8',
                maxWidth: '700px',
                margin: '0 auto 3rem auto',
                lineHeight: '1.8',
                fontWeight: '300',
                padding: '0 1rem',
              }}
            >
              Explore our complete collection of luxury electric vehicles. Download our app to see all available
              models and connect with us directly.
            </p>

            <div
              style={{
                display: 'flex',
                gap: 'clamp(1rem, 3vw, 1.5rem)',
                justifyContent: 'center',
                flexWrap: 'wrap',
                padding: '0 1rem',
              }}
            >
              {/* Google Play */}
              <a
                href="https://play.google.com/store/apps/details?id=com.company.showroom"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 'clamp(0.5rem, 2vw, 0.8rem)',
                  padding: 'clamp(0.9rem, 2.5vw, 1.2rem) clamp(1.5rem, 4vw, 2.5rem)',
                  background: 'rgba(199, 179, 129, 0.1)',
                  color: '#C7B381',
                  border: '1px solid rgba(199, 179, 129, 0.3)',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: 'clamp(0.9rem, 2.5vw, 1.05rem)',
                  textDecoration: 'none',
                  transition: 'all 0.3s',
                  flex: '1 1 auto',
                  minWidth: '200px',
                  maxWidth: '280px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(199, 179, 129, 0.2)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(199, 179, 129, 0.1)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                </svg>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: 'clamp(0.65rem, 1.8vw, 0.75rem)', opacity: 0.8 }}>GET IT ON</div>
                  <div style={{ fontSize: 'clamp(0.9rem, 2.5vw, 1.05rem)', fontWeight: '600' }}>Google Play</div>
                </div>
              </a>

              {/* App Store */}
              <a
                href="https://apps.apple.com/app/st-motors-ev/id6754755756"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 'clamp(0.5rem, 2vw, 0.8rem)',
                  padding: 'clamp(0.9rem, 2.5vw, 1.2rem) clamp(1.5rem, 4vw, 2.5rem)',
                  background: 'rgba(199, 179, 129, 0.1)',
                  color: '#C7B381',
                  border: '1px solid rgba(199, 179, 129, 0.3)',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: 'clamp(0.9rem, 2.5vw, 1.05rem)',
                  textDecoration: 'none',
                  transition: 'all 0.3s',
                  flex: '1 1 auto',
                  minWidth: '200px',
                  maxWidth: '280px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(199, 179, 129, 0.2)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(199, 179, 129, 0.1)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: 'clamp(0.65rem, 1.8vw, 0.75rem)', opacity: 0.8 }}>Download on the</div>
                  <div style={{ fontSize: 'clamp(0.9rem, 2.5vw, 1.05rem)', fontWeight: '600' }}>App Store</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VehicleList;